export default "__VITE_ASSET__DSgUG36Z__"